export const RollUpDashboardIcon = () => (
    <img className='w-7 h-7' src={`${window.location.origin}/icons/28px_RollUpDashboard.svg`} alt="Roll Up Dashboard" />
);
